export default "__VITE_ASSET__ZO3wEri8__"